(() => {
  'use strict';

  function safeStorageGet(key) {
    try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; }
  }
  function safeStorageSet(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  }

  function initReviewHub(hub) {
    if (!hub || hub.dataset.diliReviewHubReady === 'true') return;
    hub.dataset.diliReviewHubReady = 'true';

    const tabs = [...hub.querySelectorAll('[data-dili-review-tab]')];
    const panels = [...hub.querySelectorAll('[data-dili-review-panel]')];
    const viewer = hub.querySelector('[data-dili-review-viewer]');
    const viewerMedia = hub.querySelector('[data-dili-review-viewer-media]');
    const viewerRating = hub.querySelector('[data-dili-review-viewer-rating]');
    const viewerReviewer = hub.querySelector('[data-dili-review-viewer-reviewer]');
    const viewerVerified = hub.querySelector('[data-dili-review-viewer-verified]');
    const viewerDate = hub.querySelector('[data-dili-review-viewer-date]');
    const viewerTitle = hub.querySelector('[data-dili-review-viewer-title]');
    const viewerBody = hub.querySelector('[data-dili-review-viewer-body]');
    const viewerProduct = hub.querySelector('[data-dili-review-viewer-product]');
    const viewerProductImage = hub.querySelector('[data-dili-review-viewer-product-image]');
    const viewerProductTitle = hub.querySelector('[data-dili-review-viewer-product-title]');
    const viewerProductPrice = hub.querySelector('[data-dili-review-viewer-product-price]');
    const likeButton = hub.querySelector('.dili-review-viewer [data-dili-review-like]');
    const likeCount = likeButton?.querySelector('[data-dili-like-count]');
    const shareButton = hub.querySelector('.dili-review-viewer [data-dili-review-share]');
    const likeEndpoint = hub.dataset.diliLikeEndpoint || '';
    let activeCard = null;

    function selectTab(name) {
      tabs.forEach((tab) => {
        const active = tab.dataset.diliReviewTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.diliReviewPanel !== name; });
    }

    tabs.forEach((tab) => tab.addEventListener('click', () => selectTab(tab.dataset.diliReviewTab || 'product')));

    const hashTab = window.location.hash === '#all-reviews' ? 'all' : (window.location.hash === '#product-reviews' ? 'product' : '');
    if (hashTab) selectTab(hashTab);

    hub.querySelectorAll('[data-dili-load-more]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.dataset.diliLoadMore || '';
        const hiddenItems = [...hub.querySelectorAll(`[data-dili-review-page-item][data-review-group="${group}"].is-hidden`)];
        hiddenItems.slice(0, 12).forEach((item) => item.classList.remove('is-hidden'));
        const remaining = hub.querySelector(`[data-dili-review-page-item][data-review-group="${group}"].is-hidden`);
        if (!remaining) button.remove();
      });
    });

    const toggle = hub.querySelector('[data-dili-review-toggle]');
    const formWrap = hub.querySelector('[data-dili-review-form-wrap]');
    const form = hub.querySelector('[data-dili-review-form]');
    const formStatus = hub.querySelector('[data-dili-review-form-status]');

    toggle?.addEventListener('click', () => {
      if (!formWrap) return;
      formWrap.classList.toggle('is-open');
      if (formWrap.classList.contains('is-open')) formWrap.querySelector('input,textarea,button')?.focus();
    });

    function closeViewer() {
      if (!viewer) return;
      viewerMedia?.querySelector('video')?.pause();
      if (viewerMedia) viewerMedia.replaceChildren();
      if (typeof viewer.close === 'function' && viewer.open) viewer.close();
      else viewer.removeAttribute('open');
      activeCard = null;
    }

    function paintLike(card) {
      if (!likeButton || !likeCount || !card) return;
      const reviewKey = card.dataset.reviewKey || '';
      const baseLikes = Number(card.dataset.baseLikes || 0) || 0;
      const stored = safeStorageGet(`dili-review-like:${reviewKey}`);
      const liked = Boolean(stored?.liked);
      const count = Math.max(baseLikes, Number(stored?.count || 0) || 0);
      likeButton.dataset.reviewKey = reviewKey;
      likeButton.dataset.baseLikes = String(baseLikes);
      likeButton.setAttribute('aria-pressed', liked ? 'true' : 'false');
      likeButton.setAttribute('aria-label', liked ? 'Unlike this review' : 'Like this review');
      likeCount.textContent = String(count);
    }

    function openViewer(button) {
      const card = button.closest('[data-dili-review-card]');
      if (!card || !viewer || !viewerMedia) return;
      activeCard = card;
      const kind = button.dataset.mediaKind || 'image';
      const src = button.dataset.mediaSrc || '';
      if (!src) return;

      viewerMedia.replaceChildren();
      if (kind === 'video') {
        const video = document.createElement('video');
        video.src = src;
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';
        viewerMedia.appendChild(video);
        video.play().catch(() => {});
      } else {
        const image = document.createElement('img');
        image.src = src;
        image.alt = card.dataset.reviewTitle || 'Customer review image';
        viewerMedia.appendChild(image);
      }

      if (viewerRating) viewerRating.textContent = `${card.dataset.rating || '5'} ★`;
      if (viewerReviewer) viewerReviewer.textContent = card.dataset.reviewer || 'DILI Customer';
      if (viewerVerified) viewerVerified.hidden = card.dataset.reviewVerified !== 'true';
      if (viewerDate) viewerDate.textContent = card.dataset.reviewDate || '';
      if (viewerTitle) {
        viewerTitle.textContent = card.dataset.reviewTitle || '';
        viewerTitle.hidden = !card.dataset.reviewTitle;
      }
      if (viewerBody) {
        viewerBody.textContent = card.dataset.reviewBody || '';
        viewerBody.hidden = !card.dataset.reviewBody;
      }

      const productUrl = card.dataset.productUrl || '';
      if (viewerProduct) {
        viewerProduct.classList.toggle('is-unavailable', !productUrl);
        if (productUrl) viewerProduct.href = productUrl;
      }
      if (viewerProductTitle) viewerProductTitle.textContent = card.dataset.productTitle || 'View product';
      if (viewerProductPrice) viewerProductPrice.textContent = card.dataset.productPrice || '';
      if (viewerProductImage) {
        const productImage = card.dataset.productImage || '';
        viewerProductImage.hidden = !productImage;
        if (productImage) {
          viewerProductImage.src = productImage;
          viewerProductImage.alt = card.dataset.productTitle || 'Product';
        } else {
          viewerProductImage.removeAttribute('src');
        }
      }

      if (shareButton) {
        shareButton.dataset.shareUrl = productUrl || window.location.href;
        shareButton.dataset.shareTitle = card.dataset.reviewTitle || card.dataset.productTitle || document.title;
      }
      paintLike(card);

      if (typeof viewer.showModal === 'function') viewer.showModal();
      else viewer.setAttribute('open', '');
    }

    hub.addEventListener('click', (event) => {
      const mediaButton = event.target.closest('[data-dili-review-media]');
      if (mediaButton && hub.contains(mediaButton)) openViewer(mediaButton);
    });

    viewer?.querySelector('[data-dili-review-viewer-close]')?.addEventListener('click', closeViewer);
    viewer?.addEventListener('click', (event) => { if (event.target === viewer) closeViewer(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && viewer?.open) closeViewer(); });

    likeButton?.addEventListener('click', async () => {
      if (!activeCard) return;
      const reviewKey = activeCard.dataset.reviewKey || '';
      if (!reviewKey) return;
      const baseLikes = Number(activeCard.dataset.baseLikes || likeButton.dataset.baseLikes || 0) || 0;
      const storageKey = `dili-review-like:${reviewKey}`;
      const stored = safeStorageGet(storageKey);
      let liked = Boolean(stored?.liked);
      let count = Math.max(baseLikes, Number(stored?.count || likeCount?.textContent || 0) || 0);
      liked = !liked;
      count = Math.max(0, count + (liked ? 1 : -1));
      safeStorageSet(storageKey, { liked, count });
      likeButton.setAttribute('aria-pressed', liked ? 'true' : 'false');
      likeButton.setAttribute('aria-label', liked ? 'Unlike this review' : 'Like this review');
      if (likeCount) likeCount.textContent = String(count);

      if (!likeEndpoint) return;
      try {
        const response = await fetch(likeEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ review_handle: reviewKey, action: liked ? 'like' : 'unlike' })
        });
        if (!response.ok) return;
        const payload = await response.json().catch(() => ({}));
        if (Number.isFinite(Number(payload.likes))) {
          count = Number(payload.likes);
          if (likeCount) likeCount.textContent = String(count);
          safeStorageSet(storageKey, { liked, count });
        }
      } catch (_) {}
    });

    shareButton?.addEventListener('click', async () => {
      const url = shareButton.dataset.shareUrl || window.location.href;
      const title = shareButton.dataset.shareTitle || document.title;
      try {
        if (navigator.share) {
          await navigator.share({ title, url });
        } else if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(url);
          shareButton.classList.add('is-copied');
          window.setTimeout(() => shareButton.classList.remove('is-copied'), 1400);
        }
      } catch (_) {}
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const files = form.querySelector('input[type="file"]')?.files || [];
      if (files.length > 5) {
        if (formStatus) formStatus.textContent = 'Please upload no more than 5 photos/videos.';
        return;
      }
      const totalBytes = Array.from(files).reduce((sum, file) => sum + file.size, 0);
      if (totalBytes > 40 * 1024 * 1024) {
        if (formStatus) formStatus.textContent = 'Media is too large. Keep the total under 40 MB.';
        return;
      }

      const original = button?.textContent || 'Submit review';
      if (button) { button.disabled = true; button.textContent = 'Submitting…'; }
      if (formStatus) formStatus.textContent = '';
      try {
        const response = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.message || 'Review service is not connected yet.');
        if (formStatus) formStatus.textContent = payload.message || 'Thank you. Your verified review is pending approval.';
        form.reset();
      } catch (error) {
        if (formStatus) formStatus.textContent = error.message || 'Could not submit your review.';
      } finally {
        if (button) { button.disabled = false; button.textContent = original; }
      }
    });
  }

  function boot(scope = document) {
    scope.querySelectorAll?.('[data-dili-review-hub]').forEach(initReviewHub);
  }

  boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
